"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLinearWorkflowProgressIndicator = void 0;
var react_1 = require("react");
var reducer_1 = require("./reducer");
function useLinearWorkflowProgressIndicator(options) {
    var initialStepLabels = options.initialStepLabels;
    var _a = (0, react_1.useReducer)(reducer_1.reducer, {
        stepLabels: initialStepLabels,
        currentStep: 0,
        completedSteps: [],
        disabledSteps: [],
        isComplete: false,
    }), state = _a[0], dispatch = _a[1];
    return {
        stepLabels: state.stepLabels,
        completedSteps: state.completedSteps,
        disabledSteps: state.disabledSteps,
        currentStep: state.currentStep,
        isComplete: state.isComplete,
        deactivateSteps: function (steps) {
            dispatch({
                type: reducer_1.Events.DISABLE_STEPS,
                payload: {
                    steps: steps,
                },
            });
        },
        activateSteps: function (steps) {
            dispatch({
                type: reducer_1.Events.ENABLE_STEPS,
                payload: {
                    steps: steps,
                },
            });
        },
        completeStep: function (step) {
            dispatch({
                type: reducer_1.Events.COMPLETE_STEP,
                payload: {
                    step: step,
                },
            });
        },
        nextStep: function () {
            dispatch({
                type: reducer_1.Events.NEXT,
            });
        },
        previousStep: function () {
            dispatch({
                type: reducer_1.Events.BACK,
            });
        },
    };
}
exports.useLinearWorkflowProgressIndicator = useLinearWorkflowProgressIndicator;
